<template>
	<div>
		<div
			ref="ring"
			class="cursor-ring"
			:class="{ hover: isHover, 'hide-default': isSoon }"
		></div>
		<div
			ref="dot"
			class="cursor-dot"
			:class="{ 'hide-default': isSoon }"
		></div>
		<div
			ref="soon"
			class="cursor-soon"
			:class="{ show: isSoon }"
		>
			Soon
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomCursor',
	data() {
		return {
			isHover: false,
			isSoon: false,
			mx: 0,
			my: 0,
			rx: 0,
			ry: 0,
			rafId: null,
		};
	},
	mounted() {
		window.addEventListener('mousemove', this.onMouseMove);
		document.addEventListener('mouseover', this.onMouseOver);
		document.addEventListener('mouseout', this.onMouseOut);
		this.animateRing();
	},
	beforeUnmount() {
		window.removeEventListener('mousemove', this.onMouseMove);
		document.removeEventListener('mouseover', this.onMouseOver);
		document.removeEventListener('mouseout', this.onMouseOut);
		if (this.rafId) cancelAnimationFrame(this.rafId);
	},
	methods: {
		onMouseMove(e) {
			this.mx = e.clientX;
			this.my = e.clientY;
			this.$refs.dot.style.left = this.mx + 'px';
			this.$refs.dot.style.top = this.my + 'px';
			this.$refs.soon.style.left = this.mx + 'px';
			this.$refs.soon.style.top = this.my + 'px';
		},
		animateRing() {
			this.rx += (this.mx - this.rx) * 0.18;
			this.ry += (this.my - this.ry) * 0.18;
			this.$refs.ring.style.left = this.rx + 'px';
			this.$refs.ring.style.top = this.ry + 'px';
			this.rafId = requestAnimationFrame(this.animateRing);
		},
		onMouseOver(e) {
			if (e.target.closest('[data-cursor-soon]')) {
				this.isSoon = true;
				return;
			}
			if (e.target.closest('a, button')) {
				this.isHover = true;
			}
		},
		onMouseOut(e) {
			if (e.target.closest('[data-cursor-soon]')) {
				this.isSoon = false;
			}
			if (e.target.closest('a, button')) {
				this.isHover = false;
			}
		},
	},
};
</script>

<style scoped>
.cursor-dot,
.cursor-ring {
	position: fixed;
	top: 0;
	left: 0;
	pointer-events: none;
	z-index: 999;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	transition: opacity 0.3s ease;
}
.cursor-dot {
	width: 5px;
	height: 5px;
	background: var(--ink);
}
.cursor-ring {
	width: 34px;
	height: 34px;
	border: 1px solid rgba(243, 241, 236, 0.5);
	transition:
		width 0.25s ease,
		height 0.25s ease,
		border-color 0.25s ease,
		transform 0.06s linear;
}
.cursor-ring.hover {
	width: 56px;
	height: 56px;
	border-color: var(--blood-bright);
}
.cursor-ring.hide-default,
.cursor-dot.hide-default {
	opacity: 0;
}

.cursor-soon {
	position: fixed;
	top: 0;
	left: 0;
	pointer-events: none;
	z-index: 1000;
	transform: translate(-50%, -50%);
	opacity: 0;
	transition:
		opacity 0.2s ease,
		transform 0.2s ease;
	background: var(--blood-bright);
	color: #fff;
	font-family: 'JetBrains Mono', monospace;
	font-size: 10px;
	font-weight: 600;
	letter-spacing: 0.12em;
	padding: 7px 12px;
	border-radius: 999px;
	text-transform: uppercase;
	white-space: nowrap;
	box-shadow: 0 4px 14px rgba(163, 32, 32, 0.4);
}
.cursor-soon.show {
	opacity: 1;
	transform: translate(-50%, -50%) scale(1);
}

@media (max-width: 900px) {
	.cursor-dot,
	.cursor-ring,
	.cursor-soon {
		display: none;
	}
}
</style>
